import DialogNames from '~/constants/DialogNames'
import useDialog from '~/utils/useDialog'

const useCommunicationsMenuDialogs = () => {
  const [openAppointmentDialog] = useDialog(DialogNames.EVENT)
  const [openAttachmentHistoryDialog] = useDialog(
    DialogNames.MULTI_ATTACHMENT_HISTORY,
  )
  const [openNewConversationDialog] = useDialog(
    DialogNames.NEW_CONVERSATION_WITH_STEPS,
  )
  const [openDiagnosisHistoryDialog] = useDialog(DialogNames.DIAGNOSIS_HISTORY)
  const [openAddReminderDialog] = useDialog(DialogNames.ADD_REMINDER)
  const [openVaccineHistoryDialog] = useDialog(DialogNames.VACCINE_HISTORY)
  const [openVitalsDialog] = useDialog(DialogNames.VITALS)
  const [openEstimatesListDialog] = useDialog(DialogNames.ESTIMATES_LIST)
  const [openPrintCageLabelDialog] = useDialog(DialogNames.PRINT_CAGE_LABEL)
  const [openTaskDialog] = useDialog(DialogNames.TASK)

  return {
    openAppointmentDialog,
    openEditAppointmentDialog: openAppointmentDialog,
    openAttachmentHistoryDialog,
    openNewConversationDialog,
    openDiagnosisHistoryDialog,
    openAddReminderDialog,
    openVaccineHistoryDialog,
    openVitalsDialog,
    openEstimatesListDialog,
    openPrintCageLabelDialog,
    openTaskDialog,
  }
}

export default useCommunicationsMenuDialogs
